package com.mgacreative.hotelru.core.tenant

import kotlinx.browser.localStorage

actual object PlatformSessionStore {
    private const val KEY = "hotelru_active_session"

    actual fun saveSession(json: String) {
        try {
            localStorage.setItem(KEY, json)
        } catch (_: Throwable) {}
    }

    actual fun loadSession(): String? {
        return try {
            localStorage.getItem(KEY)
        } catch (_: Throwable) {
            null
        }
    }

    actual fun clearSession() {
        try {
            localStorage.removeItem(KEY)
        } catch (_: Throwable) {}
    }
}
